import type { ReactNode } from "react";
import { createPortal } from "react-dom";

import { useNavigationHoverContext } from "../contexts/NavigationHoverContext";

/** Props for {@link NavigationBarPortal} */
export interface NavigationPortalProps {
  children: ReactNode;
}

export function NavigationBarPortal({ children }: NavigationPortalProps) {
  const { panelNode } = useNavigationHoverContext();

  if (!panelNode) {
    return null;
  }

  return createPortal(children, panelNode);
}
